import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AppGlobal } from 'src/app/app.global';

/** Adress of API Server */
const endpoint = environment.Endpoint;
const backendEndpoint = environment.backendEndpoint;

@Injectable({
  providedIn: 'root'
})
export class ClientAccountService {

  /** base url for requests */
  baseUrl  = '/api/clientAccount';
  baseUrl2 = /* 'http://localhost:3030/api/v1/clientAccount';  // */ '/api/v1/clientAccount';
  endUrl   = '';

  curVersion = 1;

  constructor(private httpClient: HttpClient, private app: AppGlobal) {
    this.curVersion = this.app.userVer || 2; // environment.globalVer || 1;
    this.endUrl     = (this.curVersion === 1 ? endpoint + this.baseUrl : backendEndpoint + this.baseUrl2);
  }

/*   getAll(criteria) {
    return this.httpClient.post<any>(this.endUrl, criteria, { observe: 'response' });
  } */

  getAllForFilter(options) {
    return this.httpClient.post<any>(this.endUrl + '/forFilter', options, { observe: 'response' });
  }

  getClientAccounts(ids) {
    return this.httpClient.post<any>(this.endUrl, {client_ids: ids}, { observe: 'response' });
  }

  getByClientId(clientId: string) {
    return this.httpClient.get<any>(this.endUrl + '/' + clientId, { observe: 'response' });
  }

  update(accounts) {
    return this.httpClient.put<any>(this.endUrl, accounts, { observe: 'response' });
  }

  insert(accounts) {
    return this.httpClient.post<any>(this.endUrl + '/insert', accounts, { observe: 'response' });
  }

  _delete(accountId) {
    // return this.httpClient.delete<any>(this.endUrl + '/' + accountId, { observe: 'response' });

    return this.curVersion === 1 ? this.httpClient.delete<any>(this.endUrl + '/' + accountId, { observe: 'response' }) :
    this.httpClient.post<any>(this.endUrl + (this.curVersion === 1 ? '' : '/delete'), {ids: accountId}, { observe: 'response' });
  }

  сheckUnique(name) {
    return this.httpClient.get<any>(this.endUrl + '/сheckUnique/' + name, { observe: 'response' });
  }

  getClientID() {
    return this.httpClient.get<any>(this.endUrl + '/getClientID', { observe: 'response' });
  }
}
